import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gunybtdwvh: FaireBrandEntity = {
  token: "b_gunybtdwvh",
  type: "brand",
  name: "FurDecoration",
  avatarUrl:
    "https://cdn.faire.com/fastly/b5acf774c8330a1028631279b4e400f5e8840fd478ef4cb882760a1abb0001b4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ab0ad1fa2ecba266a8b4befc95e1650f5610fed32579294601fc6050882227f6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b5acf774c8330a1028631279b4e400f5e8840fd478ef4cb882760a1abb0001b4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ab0ad1fa2ecba266a8b4befc95e1650f5610fed32579294601fc6050882227f6.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 150,
  rating: 3.8,
  reviewCount: 201,
  isInsider: false,
  description:
    "FurDecoration is a passionate boutique that seamlessly blends the beauty of nature into fashion. In a fast-paced world where people are gradually drifting away from nature, FurDecoration exudes a unique charm by harmonizing the wild with elegance.\n\nWe haven't raised the prices, and the prices include tax. There will be no additional tax charges.\n\nIn this enchanting tale, FurDecoration ventures into the enchanting world of fur, showcasing the beauty of nature through meticulously handcrafted fur accessories and ornaments. Each piece is lovingly crafted by experienced artisans, breathing new life into carefully selected fur.\n\nThis store is not just a commercial brand but a window that showcases the fusion of nature and art. Every product conveys a profound love for nature and a deep respect for craftsmanship. Whether you're in search of a distinctive fur accessory or eager to explore the history and artistry of fur, FurDecoration welcomes you.\n\nStep into FurDecoration, and you'll feel a profound connection, bridging fashion with nature, creating an unforgettable adventure. This story will lead you to explore the allure of fur, gain insight into the art of handmade craftsmanship, and learn how to infuse the beauty of nature into your everyday life.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:59.904Z",
    importedBy: "entity-db-cli",
  },
};
